import { useCallback } from 'react';
import { ChatType } from '../../api/chats';
import { MessageType } from '../../types/message';
import { PlayableResult } from '../../components/playables-catalog';

interface UseGenerateImageProps {
  chatObj: ChatType | null;
  setChatObj: (chat: ChatType) => void;
  updateMessages: (messages: MessageType[]) => void;
  activePlayable: PlayableResult | null;
  getMessagePersona: () => string | undefined;
  handleGenerateResponse: (finalChat: ChatType) => void;
}

export const useGenerateImage = ({
  chatObj,
  setChatObj,
  updateMessages,
  activePlayable,
  getMessagePersona,
  handleGenerateResponse
}: UseGenerateImageProps) => {
  
  const handleGenerateImage = useCallback(async (prompt: string) => {
    if (!chatObj) {
      throw new Error("Cannot generate image: Chat object not available");
    }
    
    try {
      const updatedChat = await chatObj.generateImage(prompt, getMessagePersona());
      setChatObj(updatedChat);
      updateMessages(updatedChat.messages || []);
      
      // Type casting as in the original code
      const finalChat = await updatedChat.generate(activePlayable?.id as any);
      updateMessages(finalChat.messages || []);
      handleGenerateResponse(finalChat);
    } catch (err) {
      console.error('Failed to generate image:', err);
      throw err; // Re-throw to let the caller handle the error
    }
  }, [
    chatObj,
    setChatObj,
    updateMessages,
    activePlayable,
    getMessagePersona,
    handleGenerateResponse
  ]);

  return { handleGenerateImage };
};

export default useGenerateImage; 